import React, { useContext } from 'react'
import { ContentInner } from '../../../../../layout/Content'
import ReceivablesInnerStyle from './css/ReceivablesInnerStyle'
import PrinterSettingsStyle from '../../../../../../css/PrinterSettingsStyle'
import { formatNumber } from '../../../../../utilities/utilities'
import { receivablesControllerContext } from './ReceivablesController'

function ReceivablesInner() {
  const receivablesController = useContext(receivablesControllerContext)
  const { getClientDateTime, getClientTimezone } = receivablesController
  const receivables = receivablesController.receivables[0]

  return (
    <ContentInner>
      <div className='report-wrapper'>
        <div className='receivables-report-container printable'>
          <h3>Receivables Report</h3>
          <div className='dates-header-container'>
            <div>As of {new Date(getClientDateTime()).toLocaleString("en-us")} { getClientTimezone() }</div>
          </div>
          <br />
          <table className='receivables-table'>
            <thead>
              <tr>
                <th style={{textAlign: 'left'}}>Account Number</th>
                <th style={{textAlign: 'left'}}>Account Name</th>
                <th style={{textAlign: 'right'}}>Amount</th>
              </tr>
            </thead>
            {
              (receivables)
              ? receivables.map(receivable  => (
                <tbody key={receivable.account_number}>
                  <tr>
                    <td style={{textAlign: 'left'}}>{receivable.account_number.toUpperCase()}</td>
                    <td style={{textAlign: 'left'}}>{receivable.account_name}</td>
                    <td style={{textAlign: 'right'}}>{formatNumber(receivable.credit_total_balance)}</td>
                  </tr>
                </tbody>
              ))
              : null
            }

            {
              (receivables)
              ? <tbody>
                  <tr>
                    <td></td>
                    <td style={{textAlign: 'right', fontWeight: 'bold'}}>Total</td>
                    <td style={{textAlign: 'right', fontWeight: 'bold'}}>
                      { formatNumber(receivables.reduce((acc, cur) => (acc + cur.credit_total_balance), 0)) }
                    </td>
                  </tr>
                </tbody>
              : null
            }
          </table>
        </div>
      </div>
      <ReceivablesInnerStyle />
      <PrinterSettingsStyle paperWidth='8.5inch'/>
    </ContentInner>
  )
}

export default React.memo(ReceivablesInner)